/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "users-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "accomplishments-dev",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "tyc-questions-bucket113227-dev",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:7bf55f67-b48a-4571-8917-9c75b5bc623d",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_7gvqZahSn",
    "aws_user_pools_web_client_id": "2uck80cvd2tbffam5rvklt5igl",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "gencertapi",
            "endpoint": "https://kgusoqsbhg.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "userapi",
            "endpoint": "https://94c81v0pok.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "accomplishmentsapi",
            "endpoint": "https://frzgc5zrj9.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "discordapi",
            "endpoint": "https://63wel73dgi.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
